import jwt_decode from "jwt-decode";

export const decodeJwt = (jwt: string) : any => {
  return jwt_decode(jwt);
}